var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "title_sp" }, [_c("custom-breadcrumb")], 1),
    _vm._v(" "),
    _c(
      "p",
      { staticStyle: { "margin-top": "50px" } },
      [
        _c("span", [_vm._v(" Business name")]),
        _vm._v(" "),
        _c("el-input", {
          attrs: { placeholder: "Please enter business name", disabled: true },
          model: {
            value: _vm.businessName,
            callback: function($$v) {
              _vm.businessName = $$v
            },
            expression: "businessName"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      [
        _c("span", [_vm._v("Country ")]),
        _vm._v(" "),
        _c("el-input", {
          attrs: { placeholder: "Please enter country" },
          model: {
            value: _vm.country,
            callback: function($$v) {
              _vm.country = $$v
            },
            expression: "country"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      [
        _c("span", [_vm._v("Business Address")]),
        _vm._v(" "),
        _c("el-input", {
          attrs: { placeholder: "Please enter business address" },
          model: {
            value: _vm.businessAddress,
            callback: function($$v) {
              _vm.businessAddress = $$v
            },
            expression: "businessAddress"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      [
        _c("span", [_vm._v("Tax ID")]),
        _vm._v(" "),
        _c("el-input", {
          attrs: { placeholder: "Please enter tax ID" },
          model: {
            value: _vm.taxId,
            callback: function($$v) {
              _vm.taxId = $$v
            },
            expression: "taxId"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("p", [
      _c("span", [_vm._v("Contract")]),
      _vm._v(" "),
      _vm.contract
        ? _c(
            "span",
            {
              staticClass: "contract",
              on: {
                click: function($event) {
                  return _vm.downloadFile()
                }
              }
            },
            [_vm._v("Contract.pdf")]
          )
        : _c("span", [_vm._v("No contract")])
    ]),
    _vm._v(" "),
    _c(
      "p",
      [
        _c("span", [_vm._v("Annual Revenue(USD)")]),
        _vm._v(" "),
        _c("el-input", {
          attrs: { placeholder: "Please enter annual revenue" },
          model: {
            value: _vm.annualIncome,
            callback: function($$v) {
              _vm.annualIncome = $$v
            },
            expression: "annualIncome"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "p",
      [
        _c("el-button", { attrs: { type: "info", disabled: "" } }, [
          _vm._v("save")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52e4c1f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e4c1f9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/business/update-business.vue
// module id = 6oU4
// module chunks = 2